import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Edit = forwardRef<SVGSVGElement | null, IconFilledProps>(function Edit({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.616 2.82321C16.1041 2.33505 16.8956 2.33505 17.3837 2.82321L21.1766 6.6161C21.6648 7.10426 21.6648 7.89571 21.1766 8.38387L8.99461 20.5659L3.29403 21.706C2.69926 21.825 2.17488 21.3006 2.29383 20.7058L3.43395 15.0052L15.616 2.82321ZM16.4999 4.06065L13.623 6.93749L17.0624 10.3768L19.9392 7.49998L16.4999 4.06065ZM16.0017 11.4375L12.5624 7.99815L4.81575 15.7447L3.95592 20.0439L8.25509 19.1841L16.0017 11.4375Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          d='M17.3837 2.82327C16.8956 2.33511 16.1041 2.33511 15.616 2.82327L12.8535 5.58574C12.6582 5.781 12.6582 6.09758 12.8535 6.29284L17.7071 11.1464C17.9023 11.3417 18.2189 11.3417 18.4142 11.1464L21.1766 8.38393C21.6648 7.89577 21.6648 7.10432 21.1766 6.61616L17.3837 2.82327Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          d='M16.6464 12.9142C16.8417 12.7189 16.8417 12.4023 16.6464 12.2071L11.7928 7.3535C11.5976 7.15824 11.281 7.15824 11.0857 7.3535L3.43395 15.0053L2.29383 20.7059C2.17488 21.3006 2.69926 21.825 3.29403 21.7061L8.99461 20.5659L16.6464 12.9142Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'edit-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Edit;
